<script>
import compoment from '@/components/draggable/CustomComponents/ImageUpload/DImageUploadEditor'
export default {
  name: 'DColumnImageEditor',
  extends: compoment
}
</script>
